import { Link } from "react-router";
import { Icon } from "../../ui/icon";

import { type RunbookRef, runbookPath, titleOf } from "../runbooks";

/**
 * The link of a diagnostic to the section of its runbook. The text says which runbook, so a screen reader hears where it goes. The book is
 * an icon (`aria-hidden`), not an emoji: a screen reader never reads "open book" (WALK-5). A long title may wrap: `nowrap` made a card
 * header wider than a phone (390 px) and the page scrolled sideways.
 */
export function RunbookLink({
  to,
  children = "Runbook",
}: Readonly<{ to: RunbookRef; children?: string }>) {
  return (
    <Link
      className="runbook-link inline-flex min-h-11 items-center gap-1.5 text-sm text-link underline underline-offset-4 break-words hover:no-underline compact:min-h-8"
      to={runbookPath(to)}
    >
      <Icon name="book-open-01" className="size-4 shrink-0" />
      <span>
        {children}
        {children === "Runbook" ? <span className="sr-only">: {titleOf(to.slug)}</span> : null}
      </span>
    </Link>
  );
}
